import React, { useState, useEffect } from 'react';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import LoadSimple from '../../LoadSimple';

const ModalCreateAckNew = ({ props, closeAck }) => {
  const [loadingM, setLoadingM] = useState(false);
  const [closeEvent, setCloseEvent] = useState(false);
  const [falsePosiive, setFalsePosiive] = useState(false);
  const [addingException, setAddingException] = useState(false);
  const [ManttoData, setManttoData] = useState({
    description: "",
  });

  useEffect(() => {
    if (!falsePosiive) {
      setCloseEvent(false);
    }
  }, [falsePosiive]);

  const addAck = async () => {
    setAddingException(true);
    const formData = new URLSearchParams();
    formData.append("message", ManttoData.description);
    formData.append("close", closeEvent);
    formData.append("is_zabbix_event", ((props.data.alert_type == "") ? true : false));
    formData.append("is_valid", ((falsePosiive) ? 0 : 1));

    let url = (props.data.alert_type === 'correlation')
      ? props.server.url + '/api/v1/cassia/events_correlations/acknowledge/' + props.data.eventid
      : props.server.url + '/api/v1/zabbix/problems/acknowledge/' + props.data.eventid;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: formData
      });

      if (response.ok) {
        if (!closeEvent) {
          await trigger_ack();
        } else {
          await trigger_close_ack();
        }
        closeAck();
        props.handleShowPopup(capitalizeFirstLetter(lang[props.languaje]['completado']), capitalizeFirstLetter((lang[props.languaje]['regGenCorr'])), '', true);
        props.setSearchTerm("");
        setAddingException(false);
        props.search_problems();
      } else {
        throw new Error('Error en la solicitud');
      }
    } catch (error) {
      setAddingException(false);
    }
  };

  const trigger_ack = async () => {
    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/surveys/trigger_ack_creation', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data.data.survey_id != null) {
          props.setImportModalOpen(true);
          props.setSuveryId(data.data.survey_id);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const trigger_close_ack = async () => {
    try {
      const response = await fetch(props.server.url + '/api/v1/cassia/surveys/trigger_event_closing', {
        method: "POST",
        headers: {
          "Accept": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data.data.survey_id != null) {
          props.setImportModalOpen(true);
          props.setSuveryId(data.data.survey_id);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleTextAreaChange = (event) => {
    setManttoData(prev => ({ ...prev, description: event.target.value }));
  };

  return (
    <div style={{
      background: 'rgba(15, 30, 56, 0.55)',
      backdropFilter: 'blur(2px)',
      position: 'fixed', inset: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 12,
        width: '100%', maxWidth: 440,
        boxShadow: '0 20px 60px rgba(0,0,0,.3), 0 0 0 1px rgba(255,255,255,.05)',
        overflow: 'hidden',
        animation: 'slideUp 0.2s ease'
      }}>
        <style>
          {`
            @keyframes slideUp {
              from { opacity: 0; transform: translateY(12px) }
              to   { opacity: 1; transform: translateY(0) }
            }
          `}
        </style>

        {/* HEADER */}
        <div style={{ background: '#0f2d5e', padding: '14px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 30, height: 30, borderRadius: 7,
              background: 'rgba(255,255,255,.12)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#fff' }}>
                Crear Acknowledge
              </div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,.5)', marginTop: 1 }}>
                Registrar reconocimiento del evento
              </div>
            </div>
          </div>
          <button style={{
            width: 26, height: 26, borderRadius: 6,
            border: '0.5px solid rgba(255,255,255,.15)',
            background: 'rgba(255,255,255,.08)',
            cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            color: 'rgba(255,255,255,.6)'
          }} onClick={closeAck}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* BADGE EVENT ID */}
        <div style={{ background: '#f1f5f9', borderBottom: '1px solid #e2e8f0', padding: '8px 18px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 9, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.07em' }}>
            Event ID
          </span>
          <span style={{
            fontFamily: 'monospace', fontSize: 12, fontWeight: 500,
            color: '#1a56db', background: '#e8f0fe',
            border: '1px solid #c3dafe', borderRadius: 5,
            padding: '2px 10px'
          }}>
            {props.data.eventid}
          </span>
          <span style={{
            marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 5,
            fontSize: 9, fontWeight: 500, color: '#e02424',
            background: '#fee2e2', border: '1px solid #fca5a5',
            borderRadius: 4, padding: '2px 8px'
          }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#e02424', display: 'inline-block' }} />
            {props.data.Estatus || 'PROBLEM'}
          </span>
        </div>

        {/* BODY */}
        <div style={{ padding: '18px 18px 14px' }}>
          <div style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '8px 12px',
            background: '#e8f0fe', border: '1px solid #c3dafe',
            borderRadius: 7, marginBottom: 14,
            fontSize: 10, color: '#64748b'
          }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1a56db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            Al confirmar, el evento quedará registrado como reconocido.
          </div>

          <label style={{
            fontSize: 10, fontWeight: 600, color: '#334155',
            textTransform: 'uppercase', letterSpacing: '.07em',
            display: 'flex', alignItems: 'center', gap: 5,
            marginBottom: 6
          }}>
            NOTAS
          </label>
          <textarea
            placeholder="Describe las acciones tomadas..."
            value={ManttoData.description}
            onChange={handleTextAreaChange}
            maxLength={500}
            style={{
              width: '90%',
              border: '1px solid #e2e8f0', borderRadius: 7,
              color: '#334155', fontSize: 11, padding: '10px 12px',
              background: '#fff', outline: 'none',
              resize: 'none', height: 82,
              lineHeight: 1.5,
              transition: 'border-color .15s, box-shadow .15s',
              marginBottom: 16
            }}
            onFocus={e => {
              e.target.style.borderColor = '#1a56db';
              e.target.style.boxShadow = '0 0 0 3px #e8f0fe';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.boxShadow = 'none';
            }}
          />
          <div style={{ fontSize: 9, color: '#94a3b8', textAlign: 'right', marginTop: -12, marginBottom: 16 }}>
            Máx. 500 caracteres
          </div>

          <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
            {/* Falso Positivo */}
            <div
              onClick={() => setFalsePosiive(!falsePosiive)}
              style={{
                flex: 1, display: 'flex', alignItems: 'center', gap: 10,
                border: falsePosiive ? '1px solid #93c5fd' : '1px solid #e2e8f0',
                borderRadius: 8, padding: '10px 12px', cursor: 'pointer',
                background: falsePosiive ? '#e8f0fe' : '#fff',
                transition: 'all .15s', userSelect: 'none'
              }}
            >
              <div style={{
                width: 32, height: 32, borderRadius: 7,
                background: falsePosiive ? '#dbeafe' : '#f1f5f9',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1a56db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 11, fontWeight: 500, color: '#334155' }}>Falso positivo</span>
                <span style={{ fontSize: 9, color: '#94a3b8', marginTop: 1 }}>El evento no es real</span>
              </div>
              <div style={{
                width: 16, height: 16, borderRadius: 4, marginLeft: 'auto', flexShrink: 0,
                border: falsePosiive ? 'none' : '1.5px solid #cbd5e1',
                background: falsePosiive ? '#1a56db' : '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                {falsePosiive && <svg width="9" height="9" viewBox="0 0 9 9"><polyline points="1.5,4.5 3.5,7 7.5,2" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>}
              </div>
            </div>

            {/* Cerrar Evento */}
            <div
              onClick={() => {
                if (falsePosiive || props.data.Estatus === "RESOLVED") {
                  setCloseEvent(!closeEvent);
                }
              }}
              style={{
                flex: 1, display: 'flex', alignItems: 'center', gap: 10,
                border: closeEvent ? '1px solid #fde68a' : '1px solid #e2e8f0',
                borderRadius: 8, padding: '10px 12px',
                cursor: (falsePosiive || props.data.Estatus === "RESOLVED") ? 'pointer' : 'not-allowed',
                background: closeEvent ? '#fef9c3' : '#fff',
                opacity: (falsePosiive || props.data.Estatus === "RESOLVED") ? 1 : 0.6,
                transition: 'all .15s', userSelect: 'none'
              }}
            >
              <div style={{
                width: 32, height: 32, borderRadius: 7,
                background: closeEvent ? '#fef3c7' : '#f1f5f9',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                  <line x1="12" y1="9" x2="12" y2="13"></line>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 11, fontWeight: 500, color: '#334155' }}>Cerrar evento</span>
                <span style={{ fontSize: 9, color: '#94a3b8', marginTop: 1 }}>Marcar como resuelto</span>
              </div>
              <div style={{
                width: 16, height: 16, borderRadius: 4, marginLeft: 'auto', flexShrink: 0,
                border: closeEvent ? 'none' : '1.5px solid #cbd5e1',
                background: closeEvent ? '#d97706' : '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                {closeEvent && <svg width="9" height="9" viewBox="0 0 9 9"><polyline points="1.5,4.5 3.5,7 7.5,2" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>}
              </div>
            </div>
          </div>

          <div style={{ height: 1, background: '#e2e8f0', margin: '0 -18px 14px' }} />

          <div style={{ display: 'flex', gap: 8 }}>
            <button
              style={{
                flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                gap: 6, borderRadius: 7,
                border: '1px solid #e2e8f0', background: '#fff',
                color: '#334155', fontSize: 12, fontWeight: 500,
                padding: '9px 20px', cursor: 'pointer'
              }}
              onClick={closeAck}
            >
              Cancelar
            </button>
            <button
              disabled={addingException}
              style={{
                flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                gap: 6, borderRadius: 7, border: 'none',
                background: '#1a56db',
                color: '#fff', fontSize: 12, fontWeight: 500,
                padding: '9px 20px', cursor: addingException ? 'not-allowed' : 'pointer',
                opacity: addingException ? 0.7 : 1
              }}
              onClick={addAck}
            >
              {addingException ? <LoadSimple /> : 'Crear Acknowledge'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCreateAckNew;
